import { format } from 'date-fns';

export const formatDate = (date) => {
  if (!date) return 'Unknown'; // ✅ Handle missing dates

  let parsedDate;

  if (date.seconds) {
    // 🔹 Firestore Timestamp (Convert to JS Date)
    parsedDate = new Date(date.seconds * 1000);
  } else {
    // 🔹 Already a JS Date or string (Convert directly)
    parsedDate = new Date(date);
  }

  // ✅ Format as "DD Month, YYYY" (e.g., "12 March, 2024")
  return format(parsedDate, 'dd MMMM, yyyy');
};

export function formatTime(timestamp, includeSeconds = false) {
  // Handle invalid input
  if (typeof timestamp !== 'number' && !(timestamp instanceof Date)) {
    return 'Invalid Timestamp';
  }

  // Convert timestamp to Date object if it's a number
  const date = typeof timestamp === 'number' ? new Date(timestamp) : timestamp;

  // Extract hours, minutes, and seconds
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  // Determine AM/PM
  const ampm = hours >= 12 ? 'PM' : 'AM';

  // Format hours into 12-hour format
  const formattedHours = hours % 12 || 12;

  // Add leading zero to minutes (and optionally seconds)
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  // Return time string with optional seconds
  return includeSeconds
    ? `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    : `${formattedHours}:${formattedMinutes}`;
}
